import React, { useEffect, useState } from 'react';
import { microsites as FALLBACK } from '../../mock';
import { Globe, ArrowUpRight } from 'lucide-react';
import { fetchMicrosites } from '../../lib/api';

export default function OwnedMedia() {
  const [sites, setSites] = useState(FALLBACK);

  useEffect(() => {
    let alive = true;
    fetchMicrosites()
      .then((data) => {
        if (alive && Array.isArray(data) && data.length) setSites(data);
      })
      .catch(() => {
        /* keep fallback silently */
      });
    return () => {
      alive = false;
    };
  }, []);

  return (
    <section id="owned" className="py-20 lg:py-32 bg-[#0F1C40] text-[#F1EDE4] border-y border-white/10">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-8 mb-12 lg:mb-16 items-end">
          <div className="lg:col-span-6">
            <div className="flex items-center gap-2 text-[11px] font-mono uppercase tracking-widest text-white/50 mb-4">
              <span className="w-6 h-px bg-[#4ECDC4]" />
              <span>Owned Media Publishing Network</span>
            </div>
            <h2 className="text-4xl lg:text-6xl tracking-tight leading-[1.02] font-medium">
              First-party reach, <span className="font-serif italic font-normal">not rented.</span>
            </h2>
          </div>
          <div className="lg:col-span-3 lg:col-start-8">
            <div className="text-[10px] font-mono uppercase tracking-widest text-white/50 mb-2">Subscribers</div>
            <div className="text-5xl lg:text-6xl font-medium tabular tracking-tight">4.18M</div>
          </div>
          <div className="lg:col-span-3">
            <div className="text-[10px] font-mono uppercase tracking-widest text-white/50 mb-2">Monthly reach</div>
            <div className="text-5xl lg:text-6xl font-medium tabular tracking-tight text-[#4ECDC4]">1.16M</div>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-px bg-white/10">
          {sites.map((m, idx) => (
            <div key={m.domain} className="group bg-[#12234C] p-8 hover:bg-white/[0.06] hover:text-[#4ECDC4] transition-colors duration-500 cursor-pointer reveal">
              <div className="flex items-start justify-between mb-8">
                <Globe className="w-5 h-5 group-hover:text-[#4ECDC4] transition-colors" strokeWidth={1.5} />
                <span className="text-[10px] font-mono opacity-60">{String(idx + 1).padStart(2, '0')}</span>
              </div>
              <h3 className="text-xl font-medium tracking-tight">{m.name}</h3>
              <div className="text-[11px] font-mono text-white/50 group-hover:text-white/40 mt-1">{m.domain}</div>
              <div className="mt-8 pt-6 border-t border-white/10 group-hover:border-neutral-800">
                <div className="text-[10px] font-mono uppercase tracking-wider text-white/50 group-hover:text-white/40 mb-1">Subscribers</div>
                <div className="text-2xl font-medium tabular">{m.subscribers}</div>
                <div className="text-xs text-white/50 group-hover:text-white/40 mt-3">{m.vertical}</div>
              </div>
              <ArrowUpRight className="w-4 h-4 mt-4 opacity-40 group-hover:opacity-100 group-hover:text-[#4ECDC4]" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
